<template>
  <d-container fluid class="px-4 main-content-container">
    <!-- Page Header -->
    <d-row no-gutters class="py-4 page-header">
      <d-col col class="mb-4 text-center text-sm-left mb-sm-0" cols="12">
        <span class="text-uppercase page-subtitle d-block">Equipamentos</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link class="float-right text-white btn btn-success " :to="{ name: 'admin-equipment-new' }">Novo equipamento</d-link>
        <d-button type="button" @click.prevent="save" class="float-right mr-2 btn-accent">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <d-card class="mb-4 card-small">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="4">
                <h6 class="m-0">Dados cadastrais</h6>
              </d-col>
              <d-col cols="12" lg="8" class="text-right" v-if="equipment">
              </d-col>
            </d-row>
          </d-card-header>

          <equipment-form ref="equipmentForm"/>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import EquipmentForm from '_modules/equipment/components/EquipmentForm.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/EquipmentModel';

export default {
  name: 'equipment-edit',
  components: {
    EquipmentForm,
  },
  computed: {
    equipment() {
      const { equipment } = this.$store.state.equipment;
      if (equipment) {
        Events.$emit(_LOAD_MODEL_, equipment);
        return equipment;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getEquipment',
    ]),
    getEquipmentModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getEquipment(parseInt(this.$route.params.equipmentId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.equipmentForm.save();
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    if (this.$route.params.equipmentId) {
      this.getEquipmentModel();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
